module.exports = __webpack_public_path__ + "static/media/page6update.2969e58f.png";